import { createSlice } from '@reduxjs/toolkit';
import { SocketStatus } from "../../../../shared/config";
var initialState = {
  reconnectCount: 0,
  socketStatus: SocketStatus.idle
};
export var socketSlice = createSlice({
  name: 'socket',
  initialState: initialState,
  reducers: {
    setReconnectCount: function setReconnectCount(state, action) {
      state.reconnectCount = action.payload;
    },
    setSocketStatus: function setSocketStatus(state, action) {
      state.socketStatus = action.payload;
    }
  }
});
var _socketSlice$actions = socketSlice.actions,
  setReconnectCount = _socketSlice$actions.setReconnectCount,
  setSocketStatus = _socketSlice$actions.setSocketStatus;
export { setReconnectCount, setSocketStatus };